<template>
  <div class="activity-list">
    <div
      v-if="runningCount"
      class="activity-list__summary"
    >
      <span class="activity-list__pulse" />
      {{ runningCount }} running
    </div>
    <div
      v-for="(item, index) in items"
      :key="item.key || index"
      class="activity-list__item"
    >
      <span
        class="activity-list__marker"
        :class="`activity-list__marker--${item.status || 'pending'}`"
      />
      <div class="activity-list__content">
        <strong>{{ item.label }}</strong>
        <el-progress
          v-if="item.progress !== undefined"
          :percentage="item.progress"
          :show-text="false"
          :stroke-width="5"
          class="activity-list__progress"
        />
        <small v-if="item.detail">{{ item.detail }}</small>
      </div>
      <small v-if="item.progress !== undefined">{{ item.progress }}%</small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    runningCount () {
      return this.items.filter(item => item.status === 'running').length
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-list {
  position: relative;
}

.activity-list__summary {
  align-items: center;
  color: #4d5663;
  display: flex;
  font-size: 11px;
  justify-content: flex-end;
  margin-bottom: 9px;
}

.activity-list__pulse {
  background: #315bac;
  border: 2px solid #dbe4f3;
  border-radius: 50%;
  height: 8px;
  margin-right: 6px;
  width: 8px;
}

.activity-list__item {
  align-items: start;
  display: grid;
  gap: 10px;
  grid-template-columns: 10px 1fr auto;
  min-height: 58px;
}

.activity-list__marker {
  background: #fff;
  border: 2px solid #87909b;
  border-radius: 50%;
  height: 8px;
  margin-top: 4px;
  width: 8px;

  &--running {
    border-color: #315bac;
  }

  &--success {
    border-color: #2f8f6b;
  }

  &--danger {
    border-color: #bd4545;
  }
}

.activity-list__content {
  display: flex;
  flex-direction: column;
  min-width: 0;

  strong {
    color: #303844;
    font-size: 12px;
  }

  small {
    color: #8a9099;
    margin-top: 5px;
  }
}

.activity-list__progress {
  margin-top: 8px;
}

.activity-list__item > small {
  color: #4d5663;
  font-size: 10px;
  margin-top: 23px;
}
</style>
